import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import CampaignRenderer from './CampaignRenderer';
import * as CardUtils from '../utils/CardUtils';
import CardApi from '../api/CardApi';
import CampaignApi from '../api/CampaignApi';
import RedirectPreferenceApi from '../api/RedirectPreferenceApi';
import _ from 'lodash';
import * as SearchPhraseUtils from './searchPhraseUtils';
import * as DomUtils from '../utils/DomUtils';
import {getDeviceType, isMobile} from '../utils/BrowserUtils';
import FramesCache from './FramesCache';
import RedirectPreset from './RedirectPreset';
import CampaignUserTargeting from './CampaignUserTargeting';
import CardRedirection from './CardRedirection';
import parseConfigs, {collectionItemOrderSort} from './parseConfigs';
import ClientAnalytics from '../analytics/ClientAnalytics';
import humps from 'humps';
import * as RedirectPreferenceUtils from '../utils/RedirectPreferenceUtils';
import * as CampaignUtils from '../utils/CampaignUtils';
import * as RedirectConst from '../const/RedirectConst';
import {getImageUrl} from '../utils/ApiUtils';
import PollContainer from './PollContainer';
import {getFingerprints} from '../fingerprint/FingerprintUtils';
import RendererMessages from '../const/RendererMessages';
import {
  displayModes,
  pollVuCardContainerRootId,
  popupAdContainerId,
  publisherTrackingContainerId,
  renderModes
} from '../const/AugmentationConst';
import PublisherProductGrid from './PublisherProductGrid';
import PubSub from '../utils/PubSub.js';

let collections = [];

class RendererDisplayStatus {
  constructor() {
    this.vulines = {};
    this.popups = {};
  }

  isShowingVuline(slotId, selector) {
    return !!(this.vulines[slotId] || {})[selector];
  }

  markVulineShown(slotId, selector) {
    this.vulines[slotId] = this.vulines[slotId] || {};
    this.vulines[slotId][selector] = true;
  }

  isShowingPopup(slotId, mode) {
    return !!(this.popups[slotId] || {})[mode];
  }

  markPopupShown(slotId, mode) {
    this.popups[slotId] = this.vulines[slotId] || getInitDisplayedPopupByMode();
    this.popups[slotId][mode] = true;
  }
}

let rendererDisplayStatus = new RendererDisplayStatus();

function getInitDisplayedPopupByMode() {
  return {
    [renderModes.vupopup]: null,
    [renderModes.iframeVupopup]: null,
    [renderModes.iframeBottomBanner]: null,
    [renderModes.nonIframeBottomBanner]: null,
    [renderModes.nonIframeVupopup]: null,
  };
}

let lastRenderedSlotVuline = {};
let framesCache = null;
let campaignUserTargeting = null;

/**
 * Holds references to DOM elements injected through augmentation.
 * Allows to unmount injected elements.
 */
class AugmentationRegistry {
  constructor() {
    this.augmentations = {};
    PubSub.subscribe(RendererMessages.hideRenderer, ({rendererId, slotId}) => {
      this.cleanUpAugmentation(rendererId, slotId);
    });
  }

  cleanUpAugmentation(rendererId, slotId) {
    const augmentation = this.getAugmentation(rendererId, slotId);
    if (!augmentation) return;

    if (augmentation.rendererContainer) {
      try {
        ReactDOM.unmountComponentAtNode(augmentation.rendererContainer);
      } catch (e) {
        console.error(e);
      }
    }
    if (augmentation.injectedElement && augmentation.injectedElement) {
      try {
        $(augmentation.injectedElement).remove();
      } catch (e) {
        console.error(e);
      }
    }
  }

  getInitAugmentation() {
    return {
      rendererId: null,
      slotId: null,
      rendererContainer: null,
      injectedElement: null,
    };
  }

  addRendererContainer(rendererId, slotId, container) {
    const augmentation = this.getAugmentation(rendererId, slotId) || this.addEmptyAugmentation(rendererId, slotId);
    augmentation.rendererContainer = container;
  }

  getRendererContainer(rendererId, slotId) {
    const augmentation = this.getAugmentation(rendererId, slotId);
    if (!augmentation) return null;
    return augmentation.rendererContainer;
  }

  addInjectedElement(rendererId, slotId, element) {
    const augmentation = this.getAugmentation(rendererId, slotId) || this.addEmptyAugmentation(rendererId, slotId);
    augmentation.injectedElement = element;
  }

  getInjectedElement(rendererId, slotId) {
    const augmentation = this.getAugmentation(rendererId, slotId);
    if (!augmentation) return null;
    return augmentation.injectedElement;
  }

  getAugmentation(rendererId, slotId) {
    return this.augmentations[`${rendererId}-${slotId}`];
  }

  addEmptyAugmentation(rendererId, slotId) {
    const augmentation = this.getInitAugmentation();
    this.augmentations[`${rendererId}-${slotId}`] = augmentation;
    return augmentation;
  }
}

const augmentationRegistry = new AugmentationRegistry();

export function cleanUpAugmentations() {
  const augmentations = Object.values(augmentationRegistry.augmentations);
  for (const augmentation of augmentations) {
    if (augmentation.rendererContainer) {
      try {
        ReactDOM.unmountComponentAtNode(augmentation.rendererContainer);
      } catch (e) {
        console.error(e);
      }
    }
    if (augmentation.injectedElement && augmentation.injectedElement) {
      try {
        $(augmentation.injectedElement).remove();
      } catch (e) {
        console.error(e);
      }
    }
  }

  if (framesCache) {
    framesCache.deleteIframes();
  }
}


export default function augmentArticle() {
  lastRenderedSlotVuline = {};
  rendererDisplayStatus = new RendererDisplayStatus();

  return Promise.resolve((() => {
    presetRedirectPreference();

    framesCache = new FramesCache();
    framesCache.listenForRendererEvents();
    framesCache.listenForCardEvents();

    collections = [];

    const promises = [];
    const collectionIds = [];
    $('[data-collection-id]').each((i, snippetElem) => {
      const id = parseCollectionId(snippetElem);
      if (collectionIds.indexOf(id) < 0) {
        collectionIds.push(id);
      }
    });

    _.forEach(collectionIds, (publisherId) => {
      ClientAnalytics.sendHostingPageView(document.location.href,
        document.title || document.location.href,
        (isMobile.any() ? 'mobile' : 'desktop'),
        publisherId);
      ClientAnalytics.sendHostingPageViewEvent();

      if (publisherId) {
        promises.push(
          getPublisherById(publisherId).then(
            async (publisher) => {
              campaignUserTargeting = new CampaignUserTargeting(publisher, CampaignApi);
              const rendererConfigs = parseConfigs(publisher);
              const campaignIds = _(rendererConfigs).map('campaignId').uniq().value();
              const targetingResults = await Promise.all(campaignIds.map(id => campaignUserTargeting.checkUserTargeted(id)));
              const userTargetedCampaigns = campaignIds.map((id, i) => ({id, isTargeted: targetingResults[i]}));
              const userTargetedRenderers = rendererConfigs.filter(r => _.get(_.find(userTargetedCampaigns, {id: r.campaignId}), 'isTargeted', true));

              userTargetedRenderers.forEach((config) => {
                config.canRender = canRenderRenderer(config);
              });

              const filteredRenderers = _.filter(userTargetedRenderers, {canRender: true});
              const redirectInfoCache = new CardRedirection(filteredRenderers, CardApi, CampaignApi, RedirectPreferenceApi);

              if (!_.isEmpty(userTargetedCampaigns)) {
                appendPollContainerElement();
              }
              for (const renderer of filteredRenderers) {
                if (hasActiveDestinations(renderer)) {
                  await setRedirectFlagForRenderer(renderer, redirectInfoCache);
                }
                renderer.onBeforeTrigger = onBeforeTrigger.bind(this, renderer, redirectInfoCache);
                renderer.onAfterTriggered = onAfterTriggered.bind(this, renderer);
                renderSingleRenderer(renderer);
              }
              renderPublisherTrackingCodes(publisher);

              loadProductPage(publisher);

              return filteredRenderers;
            })
        );
      }
    });

    return Promise.all(promises);
  })());
}

function hasActiveDestinations(renderer) {
  const destinations = _.get(renderer, 'record.destinations');
  if (!destinations) {
    return false;
  }
  return !!_.find(destinations, {isActive: true});
}

async function setRedirectFlagForRenderer(renderer, redirectInfoCache) {
  if (renderer.campaign.isQuotaRedirectActive) {
    const quotaRedirectResult = await redirectInfoCache.getCardQuotaRedirectInfo(renderer.cardId);
    if (_.get(quotaRedirectResult, 'redirectUrl')) {
      renderer.shouldRedirect = true;
      return;
    }
  }

  if (!renderer.shouldRedirect && !_.isEmpty(renderer.campaign.redirects)) {
    const {redirects} = renderer.campaign;
    const deviceType = humps.camelize(getDeviceType());
    const needsIspCheck = _.some(redirects, r => !_.isEmpty(r.isps));
    let ispCheckResult;
    if (needsIspCheck) {
      ispCheckResult = await redirectInfoCache.getCardIspRedirectInfo(renderer.cardId);
    }
    for (const redirect of redirects) {
      const isDeviceMatched = redirect.devices.includes(deviceType) || _.isEmpty(redirect.devices);
      const isIspMatched = (!_.isEmpty(redirect.devices) && _.isEmpty(redirect.isps)) || (ispCheckResult && redirect.isps.includes(ispCheckResult.isp));
      if (isDeviceMatched && isIspMatched) {
        const destination = _.find(renderer.record.destinations, {
          isActive: true,
          name: redirect.destination
        });
        if (destination) {
          renderer.shouldRedirect = true;
          renderer.isCustomRedirect = true;
          return;
        }
      }
    }
  }

  if (!renderer.shouldRedirect && CampaignUtils.isAnyRedirectEnabled(renderer.campaign)) {
    if (renderer.campaign.isIspRedirectActive) {
      renderer.shouldRedirect = true;
      return;
    }
    if (!renderer.campaign.isCookieRedirectDisabled) {
      const cookie = framesCache.getRedirectCookie(renderer.cardId);
      if (RedirectPreferenceUtils.getDestinationForCard(cookie, renderer.record)) {
        renderer.shouldRedirect = true;
        return;
      }
    }
    if (!renderer.campaign.isFingerprintRedirectDisabled) {
      const preference = await redirectInfoCache.getFingerprintRedirectInfo();
      if (RedirectPreferenceUtils.getDestinationForCard(preference, renderer.record)) {
        renderer.shouldRedirect = true;
        return;
      }
    }
    if (renderer.isDeviceRedirectActive) {
      const deviceType = humps.camelize(getDeviceType());
      const deviceRedirect = _.get(renderer, `deviceRedirects['${deviceType}']`);
      if (deviceRedirect && deviceRedirect.destination) {
        renderer.shouldRedirect = true;
        return;
      }
    }

    if (renderer.campaign.isGeoRedirectActive) {
      const geoCheckResult = await redirectInfoCache.getCampaignGeoRedirectInfo(renderer.campaignId);
      if (!_.isEmpty(geoCheckResult)) {
        renderer.shouldRedirect = true;
      }
    }
  }
}

async function onBeforeTrigger(renderer, redirectInfoCache, e) {
  e.shouldRedirect = false;

  if (!hasActiveDestinations(renderer)) {
    return;
  }

  if (renderer.isCustomRedirect) {
    e.shouldRedirect = true;
    return;
  }

  const {record, campaign} = renderer;
  let isFirstTimeVisit = true;

  if (!campaign.isCookieRedirectDisabled) {
    const cookie = framesCache.getRedirectCookie(renderer.cardId);
    isFirstTimeVisit = cookie && !RedirectPreferenceUtils.hasVisitedCampaign(cookie, campaign.id);
  } else if (!campaign.isFingerprintRedirectDisabled) {
    const preference = redirectInfoCache.fingerprintRedirectPreference;
    isFirstTimeVisit = preference && !RedirectPreferenceUtils.hasVisitedCampaign(preference, campaign.id);
  }

  if (isFirstTimeVisit) {
    switch (campaign.firstTimeRedirectAction) {
      default:
      case RedirectConst.firstTimeRedirectActions.default: {
        e.shouldRedirect = checkShouldRedirectDefault(renderer);
        break;
      }
      case RedirectConst.firstTimeRedirectActions.networkRedirect: {
        if (_.find(record.destinations, {kind: 'network', isActive: true})) {
          e.shouldRedirect = true;
        }
        break;
      }
      case RedirectConst.firstTimeRedirectActions.noRedirect:
        e.shouldRedirect = false;
        break;
    }
  } else {
    e.shouldRedirect = checkShouldRedirectDefault(renderer);
  }
}

let pollPopup;

async function onAfterTriggered(renderer) {
  const {campaign, shouldRedirect} = renderer;

  if (shouldRedirect && !_.isEmpty(campaign.pollCampaigns)) {
    let filteredPollCampaigns = _(campaign.pollCampaigns)
      .filter(campaignItem => campaignItem.isActive)
      .uniqBy(campaignItem => _.get(campaignItem, 'pollCampaign.id'))
      .sortBy(collectionItemOrderSort)
      .map(campaignItem => campaignItem.pollCampaign)
      .value();

    const filteredPollCampaignIds = filteredPollCampaigns.map(campaign => campaign.id);
    const results = await Promise.all(filteredPollCampaignIds.map(id => campaignUserTargeting.checkUserTargeted(id)));
    const targetedCampaigns = {};

    for (let i = 0; i < filteredPollCampaignIds.length; i++) {
      targetedCampaigns[filteredPollCampaignIds[i]] = results[i];
    }

    filteredPollCampaigns = filteredPollCampaigns.filter(c => targetedCampaigns[c.id]);

    const pollCampaign = filteredPollCampaigns[0];
    if (pollCampaign) {
      const pollCards = _(pollCampaign.cards)
        .filter(cardItem => cardItem.isActive)
        .uniqBy(cardItem => _.get(cardItem, 'card.id'))
        .sortBy(collectionItemOrderSort)
        .map(cardItem => cardItem.card)
        .value();

      const pollCard = pollCards[0];
      if (pollCard) {
        pollPopup = ReactDOM.render(
          <PollContainer cardId={pollCard.id} campaignId={pollCampaign.id}/>,
          document.getElementById(pollVuCardContainerRootId));
        pollPopup.open();
      }
    }
  }
}

function checkShouldRedirectDefault(renderer) {
  return renderer.shouldRedirect;
}

function presetRedirectPreference() {
  getFingerprints(() => {
    const preset = new RedirectPreset();
    preset.loadPresetFrame();
  });
}

function parseCollectionId(snippet) {
  return $(snippet).data('collection-id');
}

function getPublisherById(id) {
  return Promise.resolve((() => {
    const cached = collections[id];
    if (cached) {
      return Promise.resolve(cached);
    }
    collections[id] = CardApi.getCollection(id);
    return collections[id];
  })());
}

function canRenderRenderer(config) {
  if (config && config.isActive) {
    const canBeDisplayed = _.isEmpty(config.devices) || _.includes(config.devices, getDeviceType());

    if (canBeDisplayed) {
      switch (config.renderMode) {
        default:
        case renderModes.inline:
          return true;
        case renderModes.vuphrase:
          return canRenderVuPhrase(config);
        case renderModes.vuline: {
          const canRender = canRenderVuLine(config);
          if (canRender) {
            if (isRendererDisplayLimited(config)) {
              updateRendererLimitedDisplayState(config);
              return false;
            }
            updateRendererLimitedDisplayState(config);
          }
          return canRender;
        }
        case renderModes.vupopup:
        case renderModes.iframeVupopup:
        case renderModes.iframeBottomBanner:
        case renderModes.nonIframeVupopup:
        case renderModes.nonIframeBottomBanner: {
          const canRender = canRenderVuPopup(config);
          if (canRender) {
            if (isRendererDisplayLimited(config)) {
              updateRendererLimitedDisplayState(config);
              return false;
            }
            updateRendererLimitedDisplayState(config);
          }
          return canRender;
        }
      }
    }
  }
  return false;
}

function renderSingleRenderer(config) {
  function renderRenderer(config) {
     switch (config.renderMode) {
      default:
        break;
      case renderModes.vuphrase:
        return renderVuPhrase(config);
      case renderModes.vuline:
        return renderVuLine(config);
      case renderModes.vupopup:
      case renderModes.iframeVupopup:
      case renderModes.iframeBottomBanner:
      case renderModes.nonIframeVupopup:
      case renderModes.nonIframeBottomBanner:
        return renderVuPopup(config);
    }
  }

  if (config.delayDuration) {
    setTimeout(() => renderRenderer(config), config.delayDuration * 1000);
  } else {
    renderRenderer(config);
  }
}

function mountRenderer(domElem, props, config) {
  if (config) {
    const {
      rendererId,
      slotId,
      renderMode,
    } = config;
    if ([renderModes.vuline, renderModes.vupopup, renderModes.iframeVupopup, renderModes.iframeBottomBanner, renderModes.nonIframeVupopup, renderModes.nonIframeBottomBanner].includes(renderMode)) {
      augmentationRegistry.addRendererContainer(rendererId, slotId, domElem);
    }
  }
  return !!ReactDOM.render(<CampaignRenderer {...props}/>, domElem);
}

function canRenderVuPopup(config) {
  const {
    exclusionSelector,
    exclusionPhrases,
    renderMode,
    slotId,
  } = config;

  if (rendererDisplayStatus.isShowingPopup(slotId, renderMode)) {
    return false;
  }

  const isExclusionFound = SearchPhraseUtils.isExclusionPhraseFound(exclusionSelector, exclusionPhrases);
  if (isExclusionFound) {
    return false;
  }

  const canRender = SearchPhraseUtils.isSearchPhraseFound(config);
  const displayLimited = isRendererDisplayLimited(config);
  if (canRender && !displayLimited) {
    rendererDisplayStatus.markPopupShown(slotId, renderMode);
  }
  return canRender;
}

function renderVuPopup(config) {
  const {renderMode, rendererId, slotId} = config;
  const containerElement = $(`#${popupAdContainerId}`)[0] || $(`<div id="${popupAdContainerId}" />`).appendTo('body')[0];
  const renderModeContainerId = `#vup-${slotId}-${renderMode}-container`;
  const renderModeContainerElement = $(renderModeContainerId)[0] || $(`<div id="${renderModeContainerId}" />`).appendTo(containerElement)[0];
  augmentationRegistry.addInjectedElement(rendererId, slotId, containerElement);
  mountRenderer(renderModeContainerElement, config);
  updateRendererDisplayCount(config);

  return true;
}

function canRenderVuPhrase(config) {
  if (config.displayMode === displayModes.phrase) {
    return canRenderPhrases(config);
  }

  return canRenderNextToPhrases(config);
}

function renderVuPhrase(config) {
  if (config.displayMode === displayModes.phrase) {
    return renderPhrases(config);
  }

  return renderNextToPhrases(config);
}

function canRenderNextToPhrases(config) {
  const {
    exclusionSelector,
    exclusionPhrases
  } = config;

  const isExclusionFound = SearchPhraseUtils.isExclusionPhraseFound(exclusionSelector, exclusionPhrases);
  if (isExclusionFound) {
    return false;
  }

  return SearchPhraseUtils.isSearchPhraseFound(config);
}

function renderNextToPhrases(config) {
  const {
    renderPhrase,
    renderSearchSelector,
    renderCount = 0
  } = config;

  const rendererProps = getRendererProps(config);
  const nextToPhrase = SearchPhraseUtils.formatTextForSearch(renderPhrase);
  let hasRendered = false;
  let foundCounter = 0;

  $(renderSearchSelector)
    .contents()
    .toArray()
    .forEach((elem) => {
      const textNodes = DomUtils.getTextNodesIn(elem, false);
      for (let i = 0; i < textNodes.length; i++) {
        const tNode = textNodes[i];
        const text = SearchPhraseUtils.formatTextForSearch(tNode.textContent);
        if (text.indexOf(nextToPhrase) > -1) {
          let replacement = '';
          const adjacentText = (i < textNodes.length - 1) ? SearchPhraseUtils.formatTextForSearch(textNodes[i + 1].textContent) : '';

          const splitTexts = SearchPhraseUtils.getSurroundingTexts(tNode.textContent, adjacentText, nextToPhrase);
          if (splitTexts.length === 1 && SearchPhraseUtils.formatTextForSearch(splitTexts[0]).trim() === nextToPhrase) {
            const splitText = splitTexts[0];
            foundCounter++;
            replacement += `${splitText}<span class="vuCardTriggerRoot"/>`;
          } else {
            for (let j = 0; j < splitTexts.length; j++) {
              const splitText = splitTexts[j];
              if (splitText) {
                hasRendered = true;
                const isNotLastSplit = (j < splitTexts.length - 1);
                if (isNotLastSplit) {
                  foundCounter++;
                }
                if (renderCount > 0 && foundCounter > renderCount) {
                  replacement += splitText;
                } else if (isNotLastSplit) {
                  replacement += `${splitText}<span class="vuCardTriggerRoot"/>`;
                } else {
                  replacement += splitText;
                }
              }
            }
          }
          const $replacement = $(`<span>${replacement}</span>`);
          $replacement.find('.vuCardTriggerRoot').each((i, e) => {
            mountRenderer(e, rendererProps);
          });
          $(tNode).replaceWith($replacement);
        }

        if (renderCount > 0 && foundCounter >= renderCount) {
          break;
        }
      }
    });

  return hasRendered;
}

function canRenderPhrases(config) {
  const {
    renderPhrase,
    exclusionSelector,
    exclusionPhrases
  } = config;

  const isExclusionFound = SearchPhraseUtils.isExclusionPhraseFound(exclusionSelector, exclusionPhrases);
  if (isExclusionFound) {
    return false;
  }

  const isPhraseFound = SearchPhraseUtils.isSearchPhraseFound(config);
  const replacePhrase = SearchPhraseUtils.formatTextForSearch(renderPhrase);

  return (replacePhrase && isPhraseFound);
}

//rendering by linking the search phrase
function renderPhrases(config) {
  const {
    renderSearchSelector,
    renderPhrase,
    isRenderPhraseRegex,
    renderCount = 0
  } = config;

  const rendererProps = getRendererProps(config);
  const replacePhrase = SearchPhraseUtils.formatTextForSearch(renderPhrase);
  let hasRendered = false;
  let foundCounter = 0;

  let reRenderPhrase = null;
  if (isRenderPhraseRegex) {
    reRenderPhrase = new RegExp(renderPhrase, 'i');
  }

  $(renderSearchSelector)
    .contents()
    .toArray()
    .forEach((elem) => {
      const textNodes = DomUtils.getTextNodesIn(elem, false);

      for (let i = 0; i < textNodes.length; i++) {
        const tNode = textNodes[i];
        const text = SearchPhraseUtils.formatTextForSearch(tNode.textContent);
        let textContainsPhrase = false;
        if (isRenderPhraseRegex) {
          textContainsPhrase = reRenderPhrase.test(text);
        } else {
          textContainsPhrase = text.indexOf(replacePhrase) > -1;
        }
        if (textContainsPhrase) {
          let replacement = '';
          const splitTexts = SearchPhraseUtils.getSurroundingTextsForPhrase(tNode.textContent, replacePhrase, isRenderPhraseRegex);
          const phrases = [];

          for (let j = 0; j < splitTexts.length; j++) {
            const splitText = splitTexts[j];
            if (splitText.phrase) {
              hasRendered = true;
              phrases.push(splitText.phrase);
              if (renderCount > 0 && ++foundCounter > renderCount) {
                replacement += splitText.before + splitText.phrase;
              } else {
                replacement += `${splitText.before}<span class="vuCardTriggerRoot"/>`;
              }
            } else {
              replacement += splitText.before;
            }
          }
          const $replacement = $(`<span>${replacement}</span>`);
          $replacement.find('.vuCardTriggerRoot').each((i, e) => {
            const props = {...rendererProps, phraseText: phrases[i]};
            mountRenderer(e, props);
          });
          $(tNode).replaceWith($replacement);
        }

        if (renderCount > 0 && foundCounter >= renderCount) {
          break;
        }
      }
    });
  return hasRendered;
}

function canRenderVuLine(config) {
  const {
    renderHeaderSelector,
    vulineSubheading,
    allowMultipleVulinesOnPage,
    exclusionSelector,
    exclusionPhrases,
    isTargeted,
    slotId,
  } = config;

  if (rendererDisplayStatus.isShowingVuline(slotId, renderHeaderSelector) && !allowMultipleVulinesOnPage) {
    return false;
  }

  const isExclusionFound = SearchPhraseUtils.isExclusionPhraseFound(exclusionSelector, exclusionPhrases);
  if (isExclusionFound) {
    return false;
  }

  const $heading = $(renderHeaderSelector);
  if (!$heading[0]) {
    return false;
  }

  if (vulineSubheading) {
    const canRender = SearchPhraseUtils.isSearchPhraseFound(config);
    const displayLimited = isRendererDisplayLimited(config);
    if (canRender && !isTargeted && !displayLimited) {
      rendererDisplayStatus.markVulineShown(slotId, renderHeaderSelector);
    }
    return canRender;
  }
  return false;
}

function isRendererDisplayLimited(config) {
  const {
    displayCount,
    displayFrequency,
    lifetimeDisplayCount,
    firstDisplay,
  } = config;

  if (displayCount || displayFrequency > 1 || lifetimeDisplayCount || firstDisplay > 1) {
    const {
      displayCountValue,
      hitCountValue,
      lifetimeDisplayCountValue,
      pageDisplayCountValue,
    } = getDisplayLimitsValues(config);

    if (displayFrequency > 1 && hitCountValue % displayFrequency > 0) {
      return true;
    }
    if (displayCount > 0 && displayCountValue >= displayCount) {
      return true;
    }
    if (lifetimeDisplayCount > 0 && lifetimeDisplayCountValue >= lifetimeDisplayCount) {
      return true;
    }
    if (firstDisplay > 1 && (pageDisplayCountValue + 1) < firstDisplay) {
      return true;
    }
  }
  return false;
}

function updateRendererLimitedDisplayState(config) {
  const {
    displayFrequency,
    displayCount,
    rendererId,
    slotId,
    firstDisplay,
  } = config;

  if (displayFrequency > 1) {
    // update hit count so next view get frequency updated
    const {hitCountValue, displayCountValue} = getDisplayLimitsValues(config);
    const blockedByDisplayCount = displayCount > 0 && displayCountValue >= displayCount;
    if (!blockedByDisplayCount) {
      setRendererDisplayHitValue(rendererId, slotId, hitCountValue + 1);
    }
  }

  if (firstDisplay > 1) {
    const {pageDisplayCountValue} = getDisplayLimitsValues(config);
    setRendererPageDisplayCountValue(rendererId, slotId, pageDisplayCountValue + 1);
  }
}

function updateRendererDisplayCount(config) {
  const {
    displayCount,
    lifetimeDisplayCount,
    rendererId,
    slotId,
    versionHash,
  } = config;

  if (displayCount) {
    const {displayCountValue} = getDisplayLimitsValues(config);
    setRendererDisplayCountValue(rendererId, slotId, displayCountValue + 1);
  }

  if (lifetimeDisplayCount) {
    const {lifetimeDisplayCountValue} = getDisplayLimitsValues(config);
    setRendererLifetimeDisplayCountValue(rendererId, slotId, lifetimeDisplayCountValue + 1);
    setRendererVersionHash(rendererId, slotId, versionHash);
  }
}

function getDisplayLimitsValues(config) {
  const {
    rendererId, slotId, versionHash = null,
  } = config;
  const todayStamp = getTodayStamp();
  const storedDisplayDate = getRendererDisplayDateValue(rendererId, slotId);
  let storedDisplayCount = getRendererDisplayCountValue(rendererId, slotId);
  let storedHitCount = getRendererDisplayHitValue(rendererId, slotId);
  let storedLifetimeDisplayCount = getRendererLifetimeDisplayCountValue(rendererId, slotId);
  const storedVersionHash = getRendererVersionHashValue(rendererId, slotId);
  const storedPageDisplayCount = getRendererPageDisplayCountValue(rendererId, slotId);

  if (storedDisplayDate !== todayStamp) {
    storedDisplayCount = 0;
    storedHitCount = 0;
    setRendererDisplayDateValue(rendererId, slotId, todayStamp);
    setRendererDisplayCountValue(rendererId, slotId, storedDisplayCount);
    setRendererDisplayHitValue(rendererId, slotId, storedHitCount);
  }

  if (storedVersionHash !== versionHash) {
    storedLifetimeDisplayCount = 0;
    setRendererLifetimeDisplayCountValue(rendererId, slotId, storedLifetimeDisplayCount);
  }

  return {
    displayCountValue: storedDisplayCount,
    hitCountValue: storedHitCount,
    lifetimeDisplayCountValue: storedLifetimeDisplayCount,
    versionHashValue: storedVersionHash,
    pageDisplayCountValue: storedPageDisplayCount,
  };
}

function getTodayStamp() {
  const today = new Date();
  return (`${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`);
}

function getRendererDisplayDateValue(rendererId, slotId) {
  return window.localStorage.getItem(`vup-renderer-display[${slotId}-${rendererId}]-day`);
}

function getRendererDisplayCountValue(rendererId, slotId) {
  return Number(window.localStorage.getItem(`vup-renderer-display[${slotId}-${rendererId}]-count`) || 0);
}

function getRendererLifetimeDisplayCountValue(rendererId, slotId) {
  return Number(window.localStorage.getItem(`vup-renderer-display[${slotId}-${rendererId}]-lifetimeCount`) || 0);
}

function getRendererVersionHashValue(rendererId, slotId) {
  return window.localStorage.getItem(`vup-renderer-display[${slotId}-${rendererId}]-versionHash`) || null;
}

function getRendererDisplayHitValue(rendererId, slotId) {
  return Number(window.localStorage.getItem(`vup-renderer-hit[${slotId}-${rendererId}]-count`) || 0);
}

function getRendererPageDisplayCountValue(rendererId, slotId) {
  return Number(window.localStorage.getItem(`vup-renderer-page-display-count[${slotId}-${rendererId}]`) || 0);
}

function setRendererDisplayDateValue(rendererId, slotId, value) {
  window.localStorage.setItem(`vup-renderer-display[${slotId}-${rendererId}]-day`, value);
}

function setRendererDisplayCountValue(rendererId, slotId, value) {
  window.localStorage.setItem(`vup-renderer-display[${slotId}-${rendererId}]-count`, value);
}

function setRendererLifetimeDisplayCountValue(rendererId, slotId, value) {
  return Number(window.localStorage.setItem(`vup-renderer-display[${slotId}-${rendererId}]-lifetimeCount`, value));
}

function setRendererVersionHash(rendererId, slotId, value) {
  if (value) {
    return window.localStorage.setItem(`vup-renderer-display[${slotId}-${rendererId}]-versionHash`, value);
  }
  return null;
}

function setRendererDisplayHitValue(rendererId, slotId, value) {
  window.localStorage.setItem(`vup-renderer-hit[${slotId}-${rendererId}]-count`, value);
}

function setRendererPageDisplayCountValue(rendererId, slotId, value) {
  return window.localStorage.setItem(`vup-renderer-page-display-count[${slotId}-${rendererId}]`, value);
}

function renderVuLine(config) {
  let {
    renderHeaderSelector,
    vulineSubheading,
    allowMultipleVulinesOnPage,
    campaignId,
    rendererId,
    slotId,
  } = config;

  const $heading = $(renderHeaderSelector).first();
  const rendererProps = getRendererProps(config);

  if (!allowMultipleVulinesOnPage && isVulineRenderedForHeader($heading, slotId)) {
    return false;
  }

  if (vulineSubheading.indexOf('{poster}') >= 0) {
    let imageMarkup = '';
    if (config.isVulinePosterEnabled) {
      const imageSrc = CardUtils.getHorizontalPosterImageUrl(config.record, false);
      imageMarkup = imageSrc ? `<img class="vuLineImage vuLineImage--card" src="${imageSrc}"/>` : '';
    }
    vulineSubheading = vulineSubheading.replace('{poster}', imageMarkup);
  }

  if (vulineSubheading.indexOf('{image}') >= 0) {
    const imageSrc = getImageUrl(config.vulineImage);
    const imageMarkup = imageSrc ? `<img class="vuLineImage vuLineImage--campaign" src="${imageSrc}"/>` : '';
    vulineSubheading = vulineSubheading.replace('{image}', imageMarkup);
  }

  vulineSubheading = vulineSubheading.replace('{iframe_url}', CampaignUtils.getPublisherIframeUrl(campaignId, rendererId));

  let $subheading;
  const triggerMarkup = `<span class="vuLineTrigger vuCardTriggerRoot" data-renderer-slot-id="${slotId}" data-renderer-id="${rendererId}"/>`;
  if (vulineSubheading.indexOf('{trigger}') >= 0) {
    vulineSubheading = vulineSubheading.replace('{trigger}', triggerMarkup);
    $subheading = $(vulineSubheading);
  } else {
    $subheading = $(vulineSubheading).append(triggerMarkup);
  }

  if (lastRenderedSlotVuline[slotId]) {
    $subheading.insertAfter(lastRenderedSlotVuline[slotId]);
  } else {
    $subheading.insertAfter($heading);
  }
  lastRenderedSlotVuline[slotId] = $subheading;

  augmentationRegistry.addInjectedElement(rendererId, slotId, $subheading);
  mountRenderer($subheading.find('.vuLineTrigger')[0], rendererProps, config);
  updateRendererDisplayCount(config);

  return true;
}

function getRendererProps(rendererConfig) {
  return {...rendererConfig};
}

function isVulineRenderedForHeader($header, slotId) {
  const vulineTrigger = $header.nextAll().find(`[data-renderer-slot-id="${slotId}"]`)[0];
  return !!vulineTrigger;
}

function renderPublisherTrackingCodes(collection) {
  let $trackingCodesContainer = $(`#${publisherTrackingContainerId}`).first();
  if (!$trackingCodesContainer.length) {
    $trackingCodesContainer = $(`<div id="${publisherTrackingContainerId}" />`).appendTo('body');
  }

  for (const slot of collection.slots) {
    if (!_.isEmpty(slot.trackingCodes)) {
      const deviceType = getDeviceType();
      slot.trackingCodes.forEach((codeObj) => {
        const trackingCode = CardUtils.getTrackingCode(codeObj, deviceType);
        if (trackingCode) {
          $trackingCodesContainer.append($(trackingCode));
        }
      });
    }
  }
}

function appendPollContainerElement() {
  $(`<div id="${pollVuCardContainerRootId}" />`).appendTo('body');
}

function loadProductPage(publisher) {
  if (!publisher) return;

  const {slots, publisherProductSources, productPageSlot: productPageSlotId} = publisher;
  if (!productPageSlotId || _.isEmpty(publisherProductSources)) return;

  const productPageSlot = slots.find(s => s.id === productPageSlotId);
  if (!productPageSlot) return;

  const productSource = findProductDataSourceByKey(publisher);
  if (!productSource) return;

  const vulineRenderer = SearchPhraseUtils.getVulineRenderer(productPageSlot);
  if (!vulineRenderer) return;

  const $heading = $(vulineRenderer.headerSelector).first();
  if (!$heading[0]) return;

  let $subheading;
  $subheading = $(vulineRenderer.subheading).append('<span class="vuLineTrigger vuProductGrid"/>');
  $subheading.insertAfter($heading);

  ReactDOM.render(<PublisherProductGrid publisherProductSource={productSource}/>, $subheading.find('.vuProductGrid')[0]);
}

function findProductDataSourceByKey(publisher) {
  const {slots, publisherProductSources, productPageSlot: productPageSlotId} = publisher;
  if (!productPageSlotId || _.isEmpty(publisherProductSources)) return;
  const productPageSlot = slots.find(s => s.id === productPageSlotId);
  if (!productPageSlot) return;

  return publisherProductSources.find(pps => SearchPhraseUtils.isKeyFoundForProductPage(productPageSlot, pps));
}